




































































































import {Component, Prop, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import StudentMixin from "@/mixins/StudentMixin";
import FscCard from "@/components/Card/FscCard.vue";
import FscCardHeader from "@/components/Card/FscCardHeader.vue";
import Validation from "@/components/Validation.vue";
import {ILanguage} from "@/interfaces/ILanguage";
import PrintButton from "@/components/Button/PrintButton.vue";
import MailButton from "@/components/Button/MailButton.vue";
import PriceMixin from "@/mixins/PriceMixin";
import _ from "lodash";
import {namespace} from "vuex-class";
import {CREATE, EDIT, COPY} from "@/constants/FormType";
import {IStudentEducation} from "@/interfaces/IStudentEducation";
import EducationItem from "@/views/Student/EducationItem.vue";
const DrivingSchool = namespace("driving-school");

const DriveBuzzConfigurationModule = namespace("drive-buzz-config");
@Component({
  components: {EducationItem, MailButton, PrintButton, Validation, FscCardHeader, FscCard},
})
export default class DriveBuzzTab extends mixins(StudentMixin, PriceMixin) {
  public name = "DriveBuzzTab";

  @Prop({default: () => []})
  public languages!: Array<ILanguage>;

  @Prop()
  public studentData!: any;

  @Prop()
  public v!: any;

  @Prop({default: () => []})
  public kiPilotPrices!: any;

  @Prop({default: () => []})
  public bookedKiPilotPrices!: any;

  @Prop()
  public formType: any;

  @Prop({ default: () => [] })
  public educationData!: any;

  public kiPilotPraxisVisible = false;

  @DriveBuzzConfigurationModule.Getter("getDataList")
  public driveBuzzConfigs: any;

  @DriveBuzzConfigurationModule.Action("findAll")
  public driveBuzzConfigFindAll: any;

  public activeTab = 0;

  public kiPilotPriceFields = [
    {label: this.$t("price_list.addon"), key: "product.name"},
    {
      label: this.$tc("general.license_class", 1),
      key: "licenseClass",
    },
    {label: this.$t("students.price"), key: "priceInEur"},
    {
      label: this.$t("students.price_combined"),
      key: "priceInEurForAdditionalClass",
    },
    {label: this.$t("general.book_goods"), key: "booked"},
  ];

  public get languageOption(): Array<any> {
    return this.languages;
  }

  protected get kiPilotPriceOption(): Array<any> {
    return this.kiPilotPrices;
  }

  protected get kiPilotPricesShown(): boolean {
    return this.studentData.kiPilotTheoryEnabled === true || this.educationData[this.activeTab]?.kiPilotPraxisEnabled === true;
  }

  protected bookedKiPilotPriceInput(val: any, data: any): void {
    if (data.booked) {
      return;
    }
    const bookedObject = {
      studentEducationId: data.studentEducation.id,
      productId: data.product.id,
      licenseClass: data.licenseClass,
    };
    this.updateSelectionBooked(bookedObject);
  }

  protected updateSelectionBooked(resource: any): any {
    if (!_.find(this.bookedKiPilotPrices, resource)) return this.bookedKiPilotPrices.push(resource);
    const index = _.findIndex(this.bookedKiPilotPrices, resource);
    if (index > -1) return this.bookedKiPilotPrices.splice(index, 1);
  }

  public mounted(): void {
    this.driveBuzzConfigFindAll({
      resource: "drive-buzz-config/current",
    });
  }

  @Watch("driveBuzzConfigs")
  private onDriveBuzzConfigs(data: any): void {
    if (!data) return;

    if (this.formType == CREATE && this.studentData.kiPilotTheoryEnabled == null) {
      this.studentData.kiPilotTheoryEnabled = data.kiPilotFunctionsEnabled;
    }

    this.kiPilotPraxisVisible = data.kiPilotPraxisVisible;
  }

  public getTabTitleByEducation(education: IStudentEducation): string {
    if (education?.licenseClassWithKeyNumber && education.licenseClassWithKeyNumber?.keyNumber) {
      return `${education.licenseClassWithKeyNumber.licenseClass}${education.licenseClassWithKeyNumber.keyNumber}`;
    } else if (education.licenseClassWithKeyNumber?.licenseClass) {
      return `${education.licenseClassWithKeyNumber.licenseClass}`;
    }
    return "-";
  }

}
